import {connect, useDispatch}  from 'react-redux';
import {actions}  from './redux_actions';

function Question({questions, nowQuestion}) {
	const dispatch = useDispatch();
	
	if (questions.length < 1) {
		return null;
	}

	let index = nowQuestion;
	
	// Необязательная защита от превышения
	if (index >= questions.length) {
		return <div>Кончились вопросы!</div>;
	}
	
	let answers = [];
	for (let i = 0; i < questions[index].answers.length; i++) {
		answers.push(<OneAnswer key={i} index={i} text={questions[index].answers[i]} />);
	}

	function handleClick(e) {
		let elem = e.target.closest('.oneAnswer');
		if (elem === null) { return; }
		
		let userAnswer = +elem.dataset.index;
		
		// Это добавление/удаление стиля нужно, чтобы на смартфонах визуально ощущался клик по ответу.
		elem.classList.add('wasClicked');
		setTimeout(() => {
			elem.classList.remove('wasClicked');
		}, 50);
		
		dispatch(actions.saveUserAnswer(index, userAnswer));
	}
	
	return (
		<div className="questionBlockWrapper">
			<h2 tabIndex="-1">Вопрос {index + 1} из {questions.length}.</h2>
			<div className="questionBlock" dangerouslySetInnerHTML={{__html: questions[index].question}} />
			<div className="answersBlock" onClick={handleClick}>{answers}</div>
		</div>
	);
};


function OneAnswer(props) {
	return (
		<div className="oneAnswer" data-index={props.index +1}>
			<div className="index">{props.index +1}</div>
			<div className="text" dangerouslySetInnerHTML={{__html: props.text}} />
		</div>
	);
}

const mapStateToProps = (state) =>  {
	return {questions: state.questions, nowQuestion: state.nowQuestion};
};

export default connect(mapStateToProps)(Question);
